<script setup lang="ts">
import SkrSpinner from '@/components/SkrSpinner.vue'
</script>

<template>
  <div class="dialog-loading-box" data-cy="dialog_loading_box" aria-busy="true">
    <skr-spinner :size="32" />
  </div>
</template>

<style lang="scss" scoped>
.dialog-loading-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35 * $bw;
  height: 35 * $bw;
  background-color: $c-white;
  border-radius: 16px;
  --skr-spinner-stroke-width: 2.9;
  @include loader-spinner;
}
</style>
